import type { ReactNode } from 'react';

export const symbol_vaping_rooms: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M315-200v-100h515q21 0 35.5 14.5T880-250q0 21-14.5 35.5T830-200H315Zm522-152q-7-7-7-18v-75q0-75-50-123t-125-48q-11 0-18-7t-7-18q0-11 7-18t18-7q34 0 55.5-24t21.5-58q0-34-21.5-58T655-830q-11 0-18-7t-7-18q0-11 7-18t18-7q54 0 90.5 39t36.5 93q0 33-12.5 57T737-650q58 20 100.5 75T880-445v75q0 11-7 18t-18 7q-11 0-18-7Zm-95 0q-7-7-7-18v-31q0-42-24.5-66T651-491h-71q-54 0-90.5-41.5T453-628q0-54 36.5-90.5T580-755q11 0 18 7t7 18q0 11-7 18t-18 7q-35 0-56 21t-21 56q0 35 21 61t56 26h71q54 0 94 37t40 91v43q0 11-7 18t-18 7q-11 0-18-7ZM285-203q-37-8-75-12.5t-75-4.5h-25q-13 0-21.5-8.5T80-250q0-13 8.5-21.5T110-280h25q37 0 75-4.5t75-12.5v94Zm135-27q8 0 14-6t6-14q0-8-6-14t-14-6q-8 0-14 6t-6 14q0 8 6 14t14 6Z"
		/>
	</svg>
);
